module.exports = __webpack_public_path__ + "img/car4.2a80e67e.png";